import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.4211 5.00031C10.5441 5.00031 9.83109 5.71331 9.83109 6.59031V9.77131C9.83109 10.6483 10.5441 11.3613 11.4211 11.3613H12.4281C13.3051 11.3613 14.0181 10.6483 14.0181 9.77131V6.59031C14.0181 5.71331 13.3051 5.00031 12.4281 5.00031H11.4211ZM12.4281 12.3613H11.4211C9.99309 12.3613 8.83109 11.1993 8.83109 9.77131V6.59031C8.83109 5.16231 9.99309 4.00031 11.4211 4.00031H12.4281C13.8551 4.00031 15.0181 5.16231 15.0181 6.59031V9.77131C15.0181 11.1993 13.8551 12.3613 12.4281 12.3613ZM5.00049 18.8735H18.9395V17.4405C18.5805 16.8435 16.5755 13.9145 11.7605 13.9145C6.96249 13.9145 5.26549 16.8855 5.00049 17.4185V18.8735ZM11.7605 12.9145C17.6355 12.9145 19.7935 16.9055 19.8825 17.0755C19.9195 17.1475 19.9395 17.2275 19.9395 17.3085V19.3735C19.9395 19.6495 19.7155 19.8735 19.4395 19.8735H4.50049C4.22349 19.8735 4.00049 19.6495 4.00049 19.3735V17.3085C4.00049 17.2415 4.01249 17.1775 4.03849 17.1155C4.10949 16.9445 5.85549 12.9145 11.7605 12.9145Z",
		fill: "white"
	})
});
export default SvgUserWhite;
